export default function MarketingFooter() {
  return (
    <footer className="mt-auto px-6 py-6 text-left text-sm text-landing-footer sm:px-10">
      <p>© {new Date().getFullYear()} Howie. All rights reserved.</p>
    </footer>
  );
}
